import { render, staticRenderFns } from "./FormMetaDatasourceDatastudio.vue?vue&type=template&id=d1cc05cc&lang=pug"
import script from "./FormMetaDatasourceDatastudio.vue?vue&type=script&lang=js"
export * from "./FormMetaDatasourceDatastudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1cc05cc')) {
      api.createRecord('d1cc05cc', component.options)
    } else {
      api.reload('d1cc05cc', component.options)
    }
    module.hot.accept("./FormMetaDatasourceDatastudio.vue?vue&type=template&id=d1cc05cc&lang=pug", function () {
      api.rerender('d1cc05cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/FormMetaDatasourceDatastudio.vue"
export default component.exports